/* eslint-disable react/require-default-props */
import React, { MouseEventHandler } from 'react';
import infoIcon from 'assets/icons/common/info.svg';
import Tooltip from '../tooltip';

type MoreInformationIconProps = {
  onClick?: MouseEventHandler<HTMLButtonElement>;
  styles?: string;
};

export default function MoreInformationIcon({ onClick, styles }: MoreInformationIconProps) {
  return (
    <Tooltip message="More information" styles="whitespace-nowrap">
      <button type="button" onClick={onClick} className={`mt-1 h-4 w-4 sm:w-6 sm:h-6 ${styles}`}>
        <img src={infoIcon} alt="More information" />
      </button>
    </Tooltip>
  );
}
